<template>
  <section class="card" @click="itemClick" :style="{ background: bgColor[index] }">
    <div class="pos-state-box" v-if="item.isDefectiveSalary === 'Y' || item.hasReviewInfo === 'Y'">
      <div v-if="item.isDefectiveSalary === 'Y'" class="pos-purple">{{$t('salsesOrder.defectiveSalesOrder')}}</div>
      <div v-else class="box-item pos-blue">
        <div class="box-value">
          {{
            item.reviewState === '-1'
              ? $t('salsesOrder.withdrawn')
              : item.reviewState === '1'
              ? $t('salsesOrder.approved')
              : item.reviewState === '2'
              ? $t('salsesOrder.rejected')
              : $t('salsesOrder.pendingApproval')
          }}
        </div>
      </div>
    </div>
    <div
      :class="[
        'card-info',
        item.id === curId && item.afterSalesType === '0' ? 'normal-card' : '',
        item.id === curId && item.afterSalesType !== '0' ? 'after-card' : ''
      ]">
      <div class="row align-center card-top">
        <span @click.stop="copyNumber(item.orderNo)">{{$t('salsesOrder.saleOrderNo')}}：{{ item.orderNo }}</span>
        <i @click.stop="copyNumber(item.orderNo)" class="iconfont icon-3zuidahua-3"></i>
      </div>

      <div class="card-body">
        <div class="item-box">
          <div class="label">{{$t('salsesOrder.documentSource')}}</div>
          <div class="value">{{ item.source === '1' ? $t('salsesOrder.sourceMobile') : item.source === '2' ? $t('salsesOrder.sourceClient') : '' }}</div>
        </div>
        <template v-if="item.afterSalesType === '0'">
          <div class="item-box">
            <div class="label">{{$t('salsesOrder.orderNature')}}</div>
            <div class="value">{{ item.orderTypeTitle }}</div>
          </div>
          <div class="item-box">
            <div class="label">{{$t('salsesOrder.performanceMethod')}}</div>
            <div class="value">{{item.brokerage === '1' ? $t('salsesOrder.individualPerformance') : item.brokerage === '2' ? $t('salsesOrder.teamPerformance') : item.brokerage === '3' ? $t('salsesOrder.distribution') : '' }}</div>
          </div>
        </template>
        <template v-else>
          <div class="item-box">
            <div class="label">{{$t('salsesOrder.originalSalesOrder')}}</div>
            <div class="value">{{ item.originalInnerSn }}</div>
          </div>
          <div class="item-box">
            <div class="label">{{$t('salsesOrder.totalQuantity')}}</div>
            <div class="value"><span>{{item.totalCount}}</span>{{$t('salsesOrder.orderUnit')}}</div>
          </div>
        </template>
        <div class="item-box">
          <div class="label">{{$t('salsesOrder.createTime')}}</div>
          <div class="value">{{ item.createTime }}</div>
        </div>
        <template v-if="item.afterSalesType === '0'">
          <div class="item-box">
            <div class="label">{{ item.brokerage === '2' ? $t('salsesOrder.teamMembers') : $t('salsesOrder.salesman') }}</div>
            <div class="value">{{ item.shoppingGuideName }}</div>
          </div>
          <div class="item-box">
            <div class="label">{{$t('salsesOrder.totalQuantity')}}</div>
            <div class="value"><span>{{item.totalCount}}</span>{{$t('salsesOrder.orderUnit')}}</div>
          </div>
        </template>
        <div class="item-box" v-if="item.aftersalesCount && item.aftersalesCount > 0">
          <div class="label">{{$t('salsesOrder.afterSalesCount')}}</div>
          <div class="value">{{ item.aftersalesCount }}</div>
        </div>
        <div class="item-box" v-if="item.reviewCount && item.reviewCount > 0">
          <div class="label">{{$t('salsesOrder.approvalCount')}}</div>
          <div class="value">{{ item.reviewCount }}</div>
        </div>
        <div class="card-state" v-if="(invoicesType === '2' && item.afterSalesType === '0') || (item.state === '-1' && item.afterSalesType === '1')">
          <span :style="{color: stateColor[item.state],borderColor: stateColor[item.state],background: stateBackground[item.state]}">{{stateText[item.state]}}</span>
        </div>
        <div class="item-box" v-if="item.aftersalesCount && item.aftersalesCount > 0">
          <div class="label">{{$t('salsesOrder.afterSalesCount')}}</div>
          <div class="value">{{ item.aftersalesCount }}</div>
        </div>
        <div class="item-box" v-if="item.reviewCount && item.reviewCount > 0">
          <div class="label">{{$t('salsesOrder.approvalCount')}}</div>
          <div class="value">{{ item.reviewCount }}</div>
        </div>
      </div>
      <div class="card-bot">
        <div class="bot-item">
          <div>{{$t('salsesOrder.amountReceivable')}}</div>
          <span>{{ item.totalAmount }}đ</span>
        </div>
        <div class="bot-item">
          <div>{{$t('salsesOrder.amountReceived')}}</div>
          <span>{{ item.realAmount }}đ</span>
        </div>
      </div>
    </div>
    <div
      class="card-select row"
      :class="[item.afterSalesType !== '0' ? 'after-angel' : 'normal-angel']"
      v-if="item.id === curId">
      <span class="iconfont icon-gou"></span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ordingCard',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    curId: {
      type: String,
      default: () => ''
    },
    invoicesType: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      stateIcon: {
        '-1': require('@/assets/images/state/cancel.png'),
        '1': require('@/assets/images/state/wpay.png'),
        '2': require('@/assets/images/state/paying.png'),
        '3': require('@/assets/images/state/finsh.png'),
        '4': require('@/assets/images/state/state-wpay.png'),
        '5': require('@/assets/images/erp/void.png')
      },
      stateText: {
        '-1': this.$t('salsesOrder.statusCancelled'),
        '1': this.$t('salsesOrder.statusPendingPayment'),
        '2': this.$t('salesRecord.paying'),
        '3': this.$t('salsesOrder.statusCompleted'),
        '4': this.$t('salsesOrder.statusPendingPayment'),
        '5': this.$t('salsesOrder.statusInvalidated')
      },
      stateColor: {
        '-1': '#404040',
        '1': '#f5222d',
        '2': '#f5222d',
        '3': '#52c41a',
        '4': '#f5222d',
        '5': '#f5222d'
      },
      stateBackground: {
        '-1': '#f5f5f5',
        '1': '#fff1f0',
        '2': '#fff1f0',
        '3': '#f6ffed',
        '4': '#fff1f0',
        '5': '#fff1f0'
      },
      bgColor: ['#067CF2', '#F00'],
      state: '',
      itemId: ''
    }
  },
  computed: {
    index() {
      if (this.item.afterSalesType !== '0') {
        return '1'
      } else {
        return '0'
      }
    }
  },
  methods: {
    itemClick() {
      this.$emit('choose', this.item.isChoose)
    },
    copyNumber(num) {
      let input = document.createElement('input')
      input.value = num
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      document.body.removeChild(input)
      this.$message({ type: 'success', message: this.$t('salsesOrder.copySuccess'), duration: 2000, showClose: true })
    }
  }
}
</script>

<style lang="scss" scoped>
.pos-blue {
  font-size: 10px;
  text-align: center;
  background-color: #2f52fc;
  border-radius: 0 4px 0 18px;
  .box-label {
    background: url('../assets/images/pos/pos-blue-l.png') no-repeat;
    background-size: 100% 100%;
    color: #2f52fc;
  }
  .box-value {
    color: #fff;
    width: 100%;
  }
}
.pos-orange {
  background-color: #fc8030;
  .box-label {
    background: url('../assets/images/pos/pos-orange-l.png') no-repeat;
    background-size: 100% 100%;
    color: #fc8030;
  }
  .box-value {
    color: #fff;
  }
}
.pos-purple {
  background: url('../assets/images/pos/pos-purple.png') no-repeat;
  background-size: 100% 100%;
  width: 110px;
  display: flex;
  justify-content: center;
  color: #fff;
  font-size: 10px;
}
.card {
  margin: 0 2px 20px;
  box-shadow: 0 0 6px 0 rgba(4, 51, 97, 0.29);
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  font-size: 15px;
  .pos-state-box {
    position: absolute;
    z-index: 0;
    top: 0;
    right: 0;
    height: 28px;
    line-height: 28px;
    font-size: 14px;
    font-weight: 100;
    .box-item {
      display: flex;
      align-items: center;
      height: 100%;
    }
    .box-label {
      width: 91px;
      position: relative;
      left: -14px;
      display: flex;
      justify-content: center;
      font-weight: 600;
    }
    .box-value {
      flex: 1;
      display: flex;
      justify-content: center;
      padding: 0 5px;
    }
  }
  .card-info {
    background: #fff;
    margin-left: 3px;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #fff;
    .card-top {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      cursor: pointer;
      font-size: 14px;
      i{
        margin-left: 4px;
      }
    }
    .card-body {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      font-size: 14px;
      justify-content: space-between;
      .item-box{
        width: 50%;
        margin-bottom: 10px;
        .label{
          color: #999;
        }
        .value{
          color: #000;
          span{
            color: #f00;
            font-weight: bold;
          }
        }
      }
    }
    .card-bot {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .bot-item{
        width: 50%;
        div{
          color: #999;
        }
        span{
          color: #f00;
          font-size: 20px;
        }
      }
    }
    .card-state {
      position: absolute;
      right: 10px;
      top: 64px;
      span{
        font-size: 12px;
        padding: 2px 5px;
        font-weight: bold;
        border-radius: 2px;
        border: 1px solid #eee;
      }
    }
  }
  .normal-card {
    background: #f6faff;
    border-color: #067cf2;
  }
  .after-card {
    background: rgb(253, 246, 246);
    border-color: #f00;
  }
  .card-select {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 60px;
    height: 60px;
    border-radius: 0 0 4px 0;
    .icon-gou {
      margin-top: 35px;
      margin-left: 28px;
      color: #fff;
    }
  }
  .normal-angel {
    background: linear-gradient(-45deg, #067cf2 50%, transparent 50%);
  }
  .after-angel {
    background: linear-gradient(-45deg, #f00 50%, transparent 50%);
  }
}
</style>
